import * as Sentry from '@sentry/browser';

/**
 * Middleware factory to collect redux related bread crumbs
 * * `filter` is used to filter out sensitive events
 * * `transformPayload` is used to filter out sensitive information
 */
const sentryMiddleware = ({
  filter = _ => true,
  transformPayload = x => x
} = {}) => () => next => action => {
  if (filter(action)) {
    Sentry.addBreadcrumb({
      message: action.type,
      category: 'redux action',
      data: {
        payload: transformPayload(action)
      }
    });
  }

  return next(action);
};

export default sentryMiddleware;
